import { Component, ElementRef, ViewChild, HostListener,ViewEncapsulation  } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CommonEventService } from '../services/common-event.service';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { LocationStrategy, Location } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';

import { FooterComponent } from '../footer/footer.component';
import { SearchAssistComponent } from '../search-assist/search-assist.component';

import { WebSocketService } from '../web-socket.service';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FooterComponent, SearchAssistComponent, FormsModule,ReactiveFormsModule, CommonModule],
    standalone: true
})

export class HomeComponent {
  uploadshow : boolean = true;
  validationCheck  : boolean = false;
  closeResult: string = '';
  uploadedFilesData :any = {};
  fileFormatError : boolean = false;
  moreFileFormatError : boolean = false;
  designPackageName :any;
  currentDateTime:any;
  fileReuploadedClicked:boolean = false;
  reUploadedFile:boolean=false;
  homePageEventObj:any = {};
  flowActivityId:any='';
  socktDataCheckLoading :boolean = false;

  
  @ViewChild("designFName") fileName!: ElementRef ;
  @ViewChild("partNum") partNumer!: ElementRef ;
  @ViewChild("partRevision") partRevision! : ElementRef ;
  // private unsubscriber : Subject<void> = new Subject<void>();
  // uploadedFilesData:any;
  constructor(
    private router: Router,
    private activatedRoute : ActivatedRoute,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private modalService: NgbModal,
    private locationStg: LocationStrategy,
    private location: Location,
    private cookieSer : CookieService,
    private socketService: WebSocketService
    ){
      // this.socket = io('https://stagingkicad6.app.protoexpress.com/socket.io/?EIO=4&transport=websocket');
    }

    ngOnInit(): void {

      // this.commonService.sessionPortalLoad();
      // this.apiService.checkCookieAPI().toPromise().then((response:any)=>{
      //   console.log(response);
      // });
      this.commonService.restrictBrowserButtons();
      localStorage.setItem('apiSerDataObj','')
      localStorage.setItem('commonDataObj','')
      localStorage.setItem('apDtId','')
      this.commonService.commonMainObj.invalidUser = false;
      window.scrollTo(0, 0);
      history.pushState(null, '');
      this.commonService.formattingCurrentDateTime();
      if(this.commonService.commonMainObj.fromWhereReupload == ''){
        this.commonService.commonMainObj.sessionFirstTimeIn = new Date();
      }
      this.fileReuploadedClicked = false;
      if(this.commonService.commonMainObj.fromWhereReupload == "otherPageReUpload"){
        this.uploadFiles(this.commonService.commonMainObj.reUploadData);  
      }else{
        this.commonService.validationLoadingShow('File validation and board data extraction is in progress, this may take a few minutes, Please wait...');
        this.activatedRoute.queryParams.subscribe(params => {
          this.commonService.commonMainObj.fileId = params['fileId'].split('.')[0];
          this.commonService.commonMainObj.fileUploadedType = params['fileId'].split('.')[1]
        });
        if(this.commonService.commonMainObj.fileId && !this.commonService.commonMainObj.backToHomePage){
          setTimeout(()=>{
            // adding for OFP-1895
            var fileIdFormData = new FormData();
            fileIdFormData.append('file_id', this.commonService.commonMainObj.fileId+'.'+this.commonService.commonMainObj.fileUploadedType);
            fileIdFormData.append('data', JSON.stringify(({})));
            this.socketService.sendMessage(fileIdFormData);
            // this.getUploadedData();
          },5000);
          // make entry in DB
          // setTimeout(()=>{
          //   console.log("")
           
          // },5000);

          // setTimeout(()=>{
          //   var uploadFileDetailsData={
          //     "pageVisited":"Date:  "+this.currentDateTime.toLocaleString().split(",")[0]+" " +"Time:"+this.currentDateTime.toLocaleString().split(",")[1],
          //     "issuesDisplayed":this.commonService.commonMainObj.fabErrWarArray
          //   }
          //   this.apiService.updateDetailsToDashboard(this.commonService.commonMainObj.fileId,uploadFileDetailsData,'UploadFileDetailsPage').subscribe((resDatas)=>{
          //   })
          // },5000);
        }else{
          if(this.commonService.commonMainObj.backToHomePage){
            this.commonService.loadingHide();           
            setTimeout(()=>{
              window.scrollTo(0, 0);
              // OFP-2505
              this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
              let uploadedDataObj={
                "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime,
                "issuesDisplayed":this.commonService.commonMainObj.uploadedFilesData.fileWarnings
              }
              this.apiService.updateDetailsToDashboard(this.flowActivityId,uploadedDataObj,'UploadFileDetailsPage').subscribe((resDatas:any)=>{
              })
            },250);
          }else{
            this.commonService.goBack();
          }
        }
        window.scrollTo(0, 0);
      }
      // setTimeout(()=>{
        // console.log(this.cookieSer.getAll())
        // this.apiService.checkCookieAPI().subscribe((resDatails)=>{
        //   console.log(resDatails);
        // })
      // },5000)
    }

    @HostListener('window:beforeunload', ['$event'])
    onBeforeUnload(event: BeforeUnloadEvent) {
      const perfEntries :any = performance.getEntriesByType("navigation");
      this.commonService.formattingCurrentDateTime();
      if (perfEntries.length > 0 && perfEntries[0].type === "reload") {
        console.log("Page was refreshed");
      }else{
        console.log("Likely tab close");
        this.homePageEventObj ={
          sourceApp: 'oneflow',
          eventType: 'FileValidation',
          // emailAddress: "",
          emailAddress: this.commonService.commonMainObj.userData.registrationEmail?this.commonService.commonMainObj.userData.registrationEmail:'',
          triggerDate:this.commonService.commonMainObj.formattedDate +'-'+this.commonService.commonMainObj.capturedEventTime,
          createdAt:this.commonService.commonMainObj.capturedEventCreatedAt
        }
        const blob = new Blob([JSON.stringify(this.homePageEventObj)], {
          type: 'application/json'
        });
        if(!this.commonService.commonMainObj.logoClicked){
          this.apiService.callAPIToSendCapturedEvent(blob);
        }
      }
      // // OFP-2560 dashboard
      this.apiService.updateSessionTimeSpent(this.commonService.commonMainObj.dashBoardActivityId? this.commonService.commonMainObj.dashBoardActivityId:this.commonService.commonMainObj.fileId,'UploadFileDetailsPage');
      console.log("checkk");
      //  event.preventDefault();
      //  event.returnValue = false;
    }
    // restrictBrowserButtons(){
    //   this.commonService.commonMainObj.openCheck = false;
    //   history.pushState({}, '', window.location.href);
    //   this.locationStg.onPopState(() => {
    //     history.pushState({}, '', window.location.href);
    //     if(!this.commonService.commonMainObj.openCheck){
    //       this.restrictBrowserButtonsAlert();
    //     }
    //   });
    // }
    // restrictBrowserButtonsAlert(){
    //   this.commonService.commonMainObj.openCheck = true;
    //   Swal.fire({
    //     title: 'Alert!',
    //     text:"Navigating back will result in the loss of data",
    //     showConfirmButton: true,
    //     showDenyButton: false,
    //     showCancelButton: true,
    //     allowOutsideClick: false,
    //     confirmButtonText: 'Ok',
    //     cancelButtonText: 'Cancel'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.commonService.goBack();
    //     } else if (result.isDismissed) {
    //       this.commonService.commonMainObj.openCheck = false;
    //     }
    //   })
    // }
    // @HostListener('window:popstate', ['$event'])
    // onPopState(event:any) {
    //   console.log('Back button pressed');
    //   event.preventDefault();
    //   this.restrictBrowserButtons();
    // }

    showImageToolTip(imgType:any){
      if(imgType == "Default_icon"){
        $('.lableImageLabel-'+imgType).html("Default value");
      }else if(imgType == "Extracted_icon"){
        $('.lableImageLabel-'+imgType).html("Extracted from uploaded data file");
      }else if(imgType == "Updated_icon"){
        $('.lableImageLabel-'+imgType).html("User updated value");
      }
      
    }
    hideImageToolTip(imgType:any){
      $('.lableImageLabel-'+imgType).html("");
    }

    changeInSelectInput(event:any){
        var currentElement = event.target.id;
        var currentElementValue = $('#'+currentElement).val(); 
      if(currentElement == "part-number" && currentElementValue != ''){
        this.commonService.commonMainObj.partNumHide = true;
        if(this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_part_number && this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_part_number == currentElementValue){
          this.commonService.commonMainObj.partNumberImg = "Extracted_icon";
        }else{
          this.commonService.commonMainObj.partNumberImg = "Updated_icon";
        }
      }else if(currentElement == "part-number" && currentElementValue == ''){
        this.commonService.commonMainObj.partNumHide = false;
      }

      if(currentElement == "part-revision" && currentElementValue != ''){
        this.commonService.commonMainObj.partRevHide= true;
        if(this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_revision && this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_revision == currentElementValue){
          this.commonService.commonMainObj.partRevisionImg = "Extracted_icon";
        }else{
          this.commonService.commonMainObj.partRevisionImg = "Updated_icon";
        }
      }else if(currentElement == "part-revision" && currentElementValue == ''){
        this.commonService.commonMainObj.partRevHide= false;
      }
      

      
    }
    
    getUploadedData(){
      this.fileFormatError = false;
      if(this.moreFileFormatError){
        this.commonService.commonMainObj.uploadedFilesData= '';
      }
      this.moreFileFormatError = false;
      this.apiService.fileDataWithId().subscribe((data:any)=>{
        // console.log("FileData", data);
        this.commonService.commonMainObj.listOfAllFiles = [];
        this.commonService.commonMainObj.fabErrWarArray=[];
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          if(data.error){
            this.commonService.alertCall('Error!!',data.description);
            //this.uploadshow = true;
            this.commonService.goBack();
          }else{
            //console.log("fileUploadedData",data);
            var dupObj = JSON.stringify(data);
            this.apiService.apiMainObj.fileUploadedData = JSON.parse(dupObj);
            this.commonService.commonMainObj.fileUploadedData = JSON.parse(dupObj);
            this.commonService.commonMainObj.bomFileIncluded = data.assemblyErrors && data.assemblyErrors.FV_BM_E01?true:false;
            this.commonService.commonMainObj.uploadedFileName = data.filename;
            this.commonService.commonMainObj.s3FileName = data.s3_file;
            this.commonService.commonMainObj.source = data.source;
            this.commonService.commonMainObj.odbFilesAvailable = data.directoryList && data.directoryList.length>0?data.directoryList[0].type == 'ODB' ? 'Yes' : 'No':'';
            this.commonService.commonMainObj.gerbersProvided = data.directoryList && data.directoryList.length>0?data.directoryList[0].type == 'GERBER' ? 'Yes' : 'No':'';
            var errorFound = false;
            this.commonService.loadingHide();
            data['fileErrors'] = [];
            if(Object.keys(data.fabErrors).length > 0){
              for(var errIndx in data.fabErrors){
                this.commonService.commonMainObj.fabErrWarArray.push(data.fabErrors[errIndx])
                if(errIndx != 'FV_GE_E00'){
                  data['fileErrors'].push(data.fabErrors[errIndx]);
                }
                if(errIndx == 'FV_GE_E00'){
                  // this.fileFormatError = true;
                  // this.moreFileFormatError = true;
                  Swal.fire({
                    title: "Warning!!",
                    text:data.fabErrors[errIndx]['error'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if(result.isConfirmed) {
                      //$("#checkFileUpload").trigger('click');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_GE_E01'){
                  this.fileFormatError = true;
                  this.moreFileFormatError = true;
                  Swal.fire({
                    title: "Error!!",
                    text:data.fabErrors[errIndx]['description'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Re-Upload Files',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                        $("#checkFileUpload").trigger('click');
                        $("#checkFileUpload").val('');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_GE_E02'){
                  let message= '';
                  errorFound = true;
                  this.moreFileFormatError = true;
                  if(data.fabErrors[errIndx]['error'].split('|').length>1){
                    data.fabErrors[errIndx]['error'] = data.fabErrors[errIndx]['error'].split('|')
                    for(let sdjfs in data.fabErrors[errIndx]['error']){
                      if(sdjfs == "0"){
                        message = message+'<li style="list-style-type:none;">'+data.fabErrors[errIndx]['error'][sdjfs]+'</li>'
                      }else{
                        message = message+'<li>'+data.fabErrors[errIndx]['error'][sdjfs]+'</li>'
                      }
                    }
                    message = '<ul style="text-align: start;">'+message+'</ul>';
                  }else{
                    message = '<div>'+data.fabErrors[errIndx]['error']+'</div>';
                  }
                  // this.commonService.confirmAlert('Error!!',data.fabErrors[errIndx]['error'],'Re-Upload Files','Cancel')
                  // text:data.fabErrors[errIndx]['error'],
                  Swal.fire({
                    title: "Error!!",
                    html:message,
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Re-Upload Files',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                        $("#checkFileUpload").trigger('click');
                        $("#checkFileUpload").val('');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_SE_E03'){
                  Swal.fire({
                    title: "Error!!",
                    text:data.fabErrors[errIndx]['error'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                      this.commonService.goBack();
                    } else if (result.isDismissed) {
                      // this.commonService.goBack();
                    }
                  })
                }
              }
            }
            if(data.fabWarnings && Object.keys(data.fabWarnings).length > 0){
              data['fileWarnings'] = [];
              for(var errIndx in data.fabWarnings){
                this.commonService.commonMainObj.fabErrWarArray.push(data.fabWarnings[errIndx])
                if(!errorFound && errIndx != 'FV_GE_E00'){
                  data['fileWarnings'].push(data.fabWarnings[errIndx]);
                }
                if(!errorFound && errIndx == 'FV_GE_E00'){
                  // this.commonService.confirmAlert('Warning!!',data.fabWarnings[errIndx]['warning'],'Ok','Cancel')
                  Swal.fire({
                    title: "Warning!!",
                    text:data.fabWarnings[errIndx]['warning'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if(result.isConfirmed) {
                      //$("#checkFileUpload").trigger('click');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }
                this.commonService.commonMainObj.boardOutlineProvided = data.fabWarnings.FV_BO_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.layerOrderProvided = data.fabWarnings.FV_CL_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.drillFileProvided = data.fabWarnings.FV_DR_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.fabDrawingProvided = data.fabWarnings.FV_FD_W00 ? 'No' : 'Yes';

              }
            }
            if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM || Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM).length == 0){
              this.commonService.commonMainObj.fileUploadedData.uploadedBOM = '';
            }
            this.validationCheck = false;
            this.commonService.commonMainObj.uploadedFilesData = data;
            this.designPackageName = this.commonService.commonMainObj.uploadedFilesData.filename ? this.commonService.commonMainObj.uploadedFilesData.filename.split('.').slice(0, -1).join('.'):'';
            // console.log("data CHECK", this.commonService.commonMainObj.uploadedFilesData);
            // this.commonService.commonMainObj.uploadedFilesData.partNumber = this.uploadedFilesData.partNumber;
            // this.commonService.commonMainObj.uploadedFilesData.partRevision = this.uploadedFilesData.partRevision;
            if(data.directoryList){
              for(let i=0; i < data.directoryList.length; i++){
                for(let k=0; k < data.directoryList[i].files.length; k++){
                  //this.listOfAllFiles['files'] = {};
                  data.directoryList[i].files[k]['mainFileType'] = data.directoryList[i].type;
                  this.commonService.commonMainObj.listOfAllFiles.push(data.directoryList[i].files[k]);
                }
                //this.listOfAllFiles['mainFileType'] = data.directoryList[i].type;
              }
            }
            // console.log("listOFFILES", this.commonService.commonMainObj.listOfAllFiles);
          }
          //window.scrollTo(0, 0);
          $('html, body').animate({scrollTop:$('#scrollTop').position().top}, '');
          this.createDataForActivityEntry();
            setTimeout(()=>{
              var uploadFileDetailsData={
                "issuesDisplayed":this.commonService.commonMainObj.fabErrWarArray
              }
              this.apiService.updateDetailsToDashboard(this.commonService.commonMainObj.fileId,uploadFileDetailsData,'UploadFileDetailsPage').subscribe((resDatas)=>{
              })
            },5000);
        },300)
      },error =>{
        this.commonService.loadingHide();
        console.log('Error in getting file data', error);
        //this.commonService.alertCall("Warning",error.error.message);
      });
    }

    selectFile() {
      let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
      element.click();
    }

    proceedCheck(){
      if(!this.uploadedFilesData.partRevision || !this.uploadedFilesData.partNumber){
        this.commonService.alertCall('Alert!!','Please fill mandatory details.');
        return false;
      }
    }
    
    // ngOnDestroy(): void {
    //   this.unsubscriber.next();
    //   this.unsubscriber.complete();
    // }

    

    uploadFiles(event:any) {
      if(!event.target.files[0]){
        this.reUploadedFile = false;
        return false;
      }
      if(event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length -1].toLowerCase() == 'tgz' || event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length -1].toLowerCase() == 'zip' || event.target.files[0].name.split('.')[event.target.files[0].name.split('.').length -1].toLowerCase() == 'tar'){
        this.commonService.validationLoadingShow('File validation and board data extraction is in progress, this may take a few minutes, Please wait...');
        this.uploadshow = false;
        this.fileReuploadedClicked = true;
        var tdata = JSON.stringify({
          "serviceType" : "Fabrication,Assembly",
          "source" : "OFP",
          "getRespId": "True",
          "parseFab": "True",
          "renderImage": "True"
        });
        var formData = new FormData();
        this.commonService.commonMainObj.file = event.target.files[0];
        // console.log("FILE", this.commonService.commonMainObj.file);
        formData.append('file', event.target.files[0]);
        formData.append('data', tdata);
        setTimeout(()=>{
          $(".progress-bar").width('60%');
        },500);
        // OFP-1895 changed for 
        // this.apiService.sendGetRequest(formData).subscribe((data: any)=>{
        this.apiService.webSocketFileUploadAPI(formData).subscribe((data: any)=>{
          // this.commonService.loadingHide();
          //$(".progress-bar").width('98%');
          this.socktDataCheckLoading = false;
          if(data.fabErrors){
            Swal.fire({
              title: "Error!!",
              text:data.fabErrors['FV_SE_E03']['error'],
              showConfirmButton: true,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result:any) => {
              if (result.isConfirmed) {
                this.commonService.goBack();
              } else if (result.isDismissed) {
                // this.commonService.goBack();
              }
            })
          }
          if(data.id){
            this.commonService.commonMainObj.fileId = '';
            this.commonService.commonMainObj.fileId = data.id.split('.')[0];
            this.commonService.commonMainObj.fileUploadedType = data.id.split('.')[1]
            this.location.go('/home'+window.location.search.split('&fileId=')[0]+'&fileId='+this.commonService.commonMainObj.fileId+'.'+this.commonService.commonMainObj.fileUploadedType);
            localStorage.setItem('fileId',this.commonService.commonMainObj.fileId);
            var reUploadParamObj ={
              "fileReUploaded":this.commonService.commonMainObj.fileId.split('.').length>0?this.commonService.commonMainObj.fileId.split('.')[0]:this.commonService.commonMainObj.fileId,
            };
            this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId == '' ? this.commonService.commonMainObj.dashBoardActivityId: this.commonService.commonMainObj.backToPrevPageActivityId;
            // this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
            if(this.commonService.commonMainObj.reUploadPageName == 'BoardDetailsPage'){
              this.apiService.updateDetailsToDashboard(this.flowActivityId,reUploadParamObj,'BoardDetailsPage').subscribe((resDatas:any)=>{
                this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
                // console.log("updateDetailsToDashboard",resDatails);
              });
              this.commonService.commonMainObj.reUploadPageName='';
            }
            else if(this.commonService.commonMainObj.reUploadPageName == 'ConfirmQuoteRequestPage' && this.commonService.commonMainObj.pcbType != 'Custom/Advanced PCB'){
              this.apiService.updateDetailsToDashboard(this.flowActivityId,reUploadParamObj,'ConfirmQuoteRequestPage').subscribe((resDatas:any)=>{
                this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
                // console.log("updateDetailsToDashboard",resDatails);
              });
              this.commonService.commonMainObj.reUploadPageName='';
            }
            else if(this.commonService.commonMainObj.reUploadPageName == 'ConfirmQuoteRequestPage' && this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
              this.apiService.updateDetailsToDashboard(this.flowActivityId,reUploadParamObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas:any)=>{
                this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
                // console.log("updateDetailsToDashboard",resDatails);
              });
              this.commonService.commonMainObj.reUploadPageName='';
            }
            else if(this.fileReuploadedClicked){
              this.commonService.commonMainObj.fromWhereReupload = "homePage";
              // this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId == '' ? this.commonService.commonMainObj.dashBoardActivityId: this.commonService.commonMainObj.backToPrevPageActivityId
              this.apiService.updateDetailsToDashboard(this.flowActivityId,reUploadParamObj,'UploadFileDetailsPage').subscribe((resDatas:any)=>{
                this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId;
                // console.log("updateDetailsToDashboard",resDatails);
              });
              // OFP-3528
              this.commonService.formattingCurrentDateTime();
              this.commonService.commonMainObj.reUploadPageName='';
            }

            // adding for OFP-1895
            var fileIdFormData = new FormData();
            fileIdFormData.append('file_id', data.id);
            fileIdFormData.append('data', JSON.stringify(({})));
            this.socketService.sendMessage(fileIdFormData);


            // this.getUploadedData();
            
            // setTimeout(()=>{ 
            //   this.createDataForActivityEntry();
            // },3000);
            // var reuploadData={
            //   "pageVisited": "Date:  "+this.currentDateTime.toLocaleString().split(",")[0]+" " +"Time:"+this.currentDateTime.toLocaleString().split(",")[1],
            //   "issuesDisplayed":this.commonService.commonMainObj.fabErrWarArray
            // }
            // setTimeout(()=>{
            //   this.apiService.updateDetailsToDashboard(this.commonService.commonMainObj.fileId,reuploadData,'UploadFileDetailsPage').subscribe((resDatas)=>{
            //   // console.log("updateDetailsToDashboard",resDatails);
            //   })
            // },3000);
          
          }
          
        },error =>{
          this.commonService.loadingHide();
        })
        // setTimeout(()=>{
        //   // this.validationCheck = false;
        //   this.uploadshow = true;
        // },3000)
      }else{
        this.commonService.showtoast('Supported File Formats: zip/tar/tgz type.','warning');
        this.reUploadedFile = false;
        return false;
      }
    }

    proceedToBoardsDetails(){
      this.commonService.sessionPortalLoad();
      if(this.commonService.commonMainObj.designPackageName && this.commonService.commonMainObj.uploadedFileName && this.commonService.commonMainObj.uploadedFilesData.partNumber && this.commonService.commonMainObj.uploadedFilesData.partRevision){
        if(this.commonService.commonMainObj.uploadedFilesData.partRevision.indexOf(' ')>=0){
          this.commonService.showtoast('Spaces are not allowed for ‘Revision’','warning');
          return false;
        }
        if((this.commonService.commonMainObj.uploadedFilesData.partRevision+'').length <= 10 && (this.commonService.commonMainObj.uploadedFilesData.partNumber+'').length <= 40){
          if(!this.commonService.commonMainObj.drill_data || !this.commonService.commonMainObj.fabrication_drawing || !this.commonService.commonMainObj.pcb_additional_fast){
            if(!this.socktDataCheckLoading){
              this.socktDataCheckLoading = true;
              this.commonService.validationLoadingShow('Please wait, we are fetching board parameters...');
            }
            this.checkForBoardDetailsPageData();
            return false;
          }
          if(this.commonService.commonMainObj.userSessionMemberId != null && this.commonService.commonMainObj.isGuestUser == false){
            if(!this.socktDataCheckLoading){
              this.commonService.loadingShow();
            }
            setTimeout(()=>{
              this.commonService.sessionPortalLoad();
              this.commonService.loadingHide();
              this.apiService.checkUserSessionApi().subscribe((data: any)=>{  
                if(data.status == 1){
                  this.router.navigateByUrl('/boardDetails');
                }
              },error =>{
                console.log('Error in checking user session', error);   
              })
            },1500);
          }else{
            this.router.navigateByUrl('/boardDetails'); 
          }
        }else{
          if((this.commonService.commonMainObj.uploadedFilesData.partNumber+'').length > 40 ){
            // this.commonService.alertCall('Warning!!',"Maximum allowed length for ‘Part Number’ is 40");
            this.commonService.showtoast('Maximum allowed length for ‘Part Number’ is 40','warning');
          }else if((this.commonService.commonMainObj.uploadedFilesData.partRevision+'').length > 10){
            // this.commonService.alertCall('Warning!!',"Maximum allowed length for ‘Revision’ is 10");
            this.commonService.showtoast('Maximum allowed length for ‘Revision’ is 10','warning');
          }
          // $('html, body').animate({scrollTop:$('#scrollTop').position().top}, '');
        }
      }else{
        //console.log("commonService.commonMainObj.uploadedFilesData.partNumber",this.commonService.commonMainObj.uploadedFilesData.partNumber);
        if(this.commonService.commonMainObj.designPackageName == '' || this.commonService.commonMainObj.designPackageName == undefined){
          $('#designer-package-name').addClass('border-red');
          this.fileName.nativeElement.focus();
        }else if(this.commonService.commonMainObj.uploadedFilesData.partNumber == '' || this.commonService.commonMainObj.uploadedFilesData.partNumber == undefined){
          $('#part-number').addClass('border-red');
          this.partNumer.nativeElement.focus();
        }else if(this.commonService.commonMainObj.uploadedFilesData.partRevision == ''|| this.commonService.commonMainObj.uploadedFilesData.partRevision == undefined){
          $('#part-revision').addClass('border-red');
          this.partRevision.nativeElement.focus();
        }
        this.commonService.showtoast('Please fill mandatory details.','warning');
        // this.commonService.alertCall('Alert!!','Please fill mandatory details.');
      }
    }

    reUploadFiles(){
      this.commonService.sessionPortalLoad();
      //this.uploadshow = true;
      //this.validationCheck = false;
      //this.closeResult = '';
      //this.commonService.commonMainObj.uploadedFilesData = {};
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.loadingShow();
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          // this.commonService.sessionPortalLoad();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            this.commonService.loadingHide();
            if(data.status == 1){
              $("#checkFileUpload").trigger('click');
              $("#checkFileUpload").val('');
            }
          },error =>{
            console.log('Error in checking user session', error);
          })
        },2000);
      }else{
        $("#checkFileUpload").trigger('click');
        $("#checkFileUpload").val('');
      }
      
      //this.moreFileFormatError = false;
    }

    open(content:any) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }

    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

    showToolTip(text:any,index:any){
      $("#infoIcon-"+index).html(text);
    }
    hideToolTip(text:any,index:any){
      $("#infoIcon-"+index).html("");
    }
    
    fileNameChange(eve:any){
      console.log("eve",eve.target.value);
      var forbiddenChars = new RegExp("\\s*[. ]");
      if(forbiddenChars.test(this.commonService.commonMainObj.designPackageName)){
        this.commonService.commonMainObj.designPackageName=this.commonService.commonMainObj.designPackageName.replace(forbiddenChars,'');
      }
      this.commonService.commonMainObj.uploadedFilesData.filename = this.commonService.commonMainObj.designPackageName+".zip"
    }

    createDataForActivityEntry(){
      var pActivityId;
      if(this.commonService.commonMainObj.fromWhereReupload != ''){
        pActivityId = this.commonService.commonMainObj.parentDashboardActivityId;
      }else{
        pActivityId = null;
      }
      var activityDataObj:any = {
        "activityId": this.commonService.commonMainObj.fileId,
        "parentActivityId": pActivityId,
        "emailId": this.commonService.commonMainObj.isGuestUser == false ? this.commonService.commonMainObj.userData.registrationEmail : this.commonService.commonMainObj.email,
        "source":this.commonService.commonMainObj.fromWhereReupload != '' ? 'File Re-upload': 'Portal Home Page',
        "guestUser": this.commonService.commonMainObj.isGuestUser == true ? 'true':'false',
        "designFileName":this.commonService.commonMainObj.uploadedFileName
      }
      this.apiService.requestForActivityEntryInDb(activityDataObj).subscribe((res: any)=>{
        this.commonService.commonMainObj.dashBoardActivityId=res.activityId;
      },error =>{
        // console.log('Error in creating entry in db', error);   
      })
      if(this.commonService.commonMainObj.userSessionMemberId){
        setTimeout(()=>{
          // this.commonService.sessionPortalLoad();
          this.apiService.checkUserSessionApi().subscribe((data: any)=>{  
          },error =>{
            console.log('Error in checking user session', error);   
          })
        },800);
      }
    }
  
    openModal(content:any){
      var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
        modalRef.result.then((result) => {
          this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    checkForBoardDetailsPageData(){
      setTimeout(()=>{
        this.proceedToBoardsDetails();
      },1000)
    }

}


